import { SxProps, Theme } from '@mui/material';

export const useCommonClasses = (theme: Theme) => ({
  wrapper: {
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
    '& .MuiIconButton-root': {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    '& .MuiInputBase-root.MuiInput-root': {
      fontSize: '.95rem',
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root': {
      fontSize: theme.spacing(3.5),
    },
  },
  textField: {
    '& .MuiInputBase-root.MuiInput-root': {
      color: theme.palette.primary.main,
      flexGrow: 1,
      fontWeight: 'bold',
      marginRight: 1,
      width: '100%',
    },
    '& .input': {
      width: 'fit-content',
    },
  },
});

export const pickerContainerSx: SxProps = {
  alignItems: 'center',
  borderRadius: 0.5,
  display: 'flex',
  flexDirection: 'row',
  width: 'fit-content',
};

export const pickerTextfieldSx: SxProps = {
  color: 'primary.main',
  flexGrow: 1,
  fontWeight: 'bold',
  pl: 0,
};
